import React, { useEffect, useState } from 'react';
import Dashboard from './components/Dashboard';
import HelpButton from './components/HelpButton';
import ChatBot from './components/ChatBot';
import { axios_post } from './axios';
import { encryptWithAES } from './helper';

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }
function App() {

  const [chatOpen, setChatOpen] = useState(false);
  const [ChatColor, setChatColor] = useState('#007BFF');
  const handleHelpClick = () => {
    setChatOpen(!chatOpen);
  };
  const [questionAnswersApiRespo, setQuestionAnswersApiRespo] = useState({});
  const handleloadData = async () => {
    const params = new URLSearchParams(window.location.search);
    const website_key = params.get('website_key');
    const website_url = params.get('website_url');

    try {
      const response = await axios_post(false, '/websit-load', {
        'website_url': website_url,
        'website_key': encryptWithAES(website_key)
      });
      const reply = response.data;
      console.log('API Response:', reply);
      console.log('Questions:', reply.question_answers);

      setChatColor(reply.website_color || '#007BFF');
      setQuestionAnswersApiRespo(reply.question_answers || {});
    } catch (error) {
      console.log('errpr')
    }
  }

  useEffect(() => {
    handleloadData()
  }, [])


  return (
    <div className="App">
      {<ChatBot chatColor={ChatColor} onClose={handleHelpClick} questionAnswersApi={questionAnswersApiRespo} />}
      {/* <HelpButton onClick={handleHelpClick} /> */}
    </div>
  );
}

export default App;
